<template>
  <div class="col-12">
    <div class="card mb-5" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ t('guardians.add.title') }}
            </h6>
          </div>
        </div>
      </div>

      <div class="card-body px-0 pb-2">
        <div class="row justify-content-center">
          <div class="col-12">
            <GuardianForm
              ref="guardianForm"
              :title="t('guardians.add.title')"
              :submit-text="t('guardians.add.submit')"
              :loading="isSubmitting"
              @submit="handleSubmit"
              @cancel="handleCancel"
              @validation-error="handleValidationError"
            />
          </div>
        </div>

        <div class="d-flex gap-3 mt-3 ms-3">
          <button
            type="button"
            class="btn btn-primary btn-sm flex-grow-1"
            @click="submitForm"
            :disabled="isSubmitting"
          >
            <span v-if="isSubmitting">
              <i class="fas fa-spinner fa-spin ms-2"></i>
              {{ t('guardians.add.saving') }}
            </span>
            <span v-else>
              <i class="fas fa-save ms-2"></i>
              {{ t('guardians.add.submit') }}
            </span>
          </button>

          <button
            type="button"
            class="btn btn-outline-secondary btn-sm flex-grow-1"
            @click="handleCancel"
            :disabled="isSubmitting"
          >
            <i class="fas fa-times ms-2"></i>
            {{ t('guardians.add.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import GuardianForm from "@/components/features/guardians/GuardianForm.vue";
import { useToast } from "vue-toastification";

const { t } = useI18n();
const toast = useToast();
const router = useRouter();
const store = useStore();
const guardianForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    await store.dispatch("guardian/createGuardian", formData);
    toast.success(t("guardians.add.success"));
    await router.push({ name: "guardians.index" });
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errors = error.response.data.errors;
      for (const field in errors) {
        toast.error(errors[field][0]);
      }
    } else {
      toast.error(error.response?.data?.message || t("guardians.add.createError"));
    }
  } finally {
    isSubmitting.value = false;
  }
};

const handleValidationError = () => {
  toast.warning(t("guardians.add.validationError"));
};

const submitForm = () => {
  if (guardianForm.value) {
    guardianForm.value.submitForm();
  }
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push({ name: "guardians.index" });
  }
};
</script>
